import ConfirmDialog from './ConfirmDialog';

export default { 
  name: "confirm", 
  component: ConfirmDialog, 
  fullScreen: false
};